import { AggregatedMetrics, AnalyticsGlobalFilters } from "./constants";

export const GET_AGGREGATED_METRICS = "analytics/GET_AGGREGATED_METRICS";
export const GET_AGGREGATED_METRICS_FAILURE =
  "analytics/GET_AGGREGATED_METRICS_FAILURE";
export const ADD_AGGREGATED_METRICS = "analytics/ADD_AGGREGATED_METRICS";
export const SET_AGGREGATED_METRICS_LOADING =
  "analytics/SET_AGGREGATED_METRICS_LOADING";
export const RESET_AGGREGATED_METRICS = "analytics/RESET_AGGREGATED_METRICS";
export const GET_PUBLICATIONS_FAILURE = "analytics/GET_PUBLICATIONS_FAILURE";
export const ADD_PUBLICATIONS = "analytics/ADD_PUBLICATIONS";
export const REMOVE_PUBLICATIONS = "analytics/REMOVE_PUBLICATIONS";
export const GET_PUBLICATIONS = "analytics/GET_PUBLICATIONS";
export const GET_TOPLINE_METRICS_FAILURE =
  "analytics/GET_TOPLINE_METRICS_FAILURE";
export const SET_METRICS_CONTAINER_TAB = "analytics/SET_METRICS_CONTAINER_TAB";
export const SET_METRIC_SELECTION = "analytics/SET_METRIC_SELECTION";
export const SET_MERCHANT_SELECTION = "analytics/SET_MERCHANT_SELECTION";
export const SET_PUBLICATION_SELECTION = "analytics/SET_PUBLICATION_SELECTION";
export const SET_START_DATE = "analytics/SET_START_DATE";
export const SET_END_DATE = "analytics/SET_END_DATE";
export const SET_PUBLICATIONS_LOADING = "analytics/SET_PUBLICATIONS_LOADING";
export const GET_ANALYTICS_MERCHANT = "user/api/GET_ANALYTICS_MERCHANT";
export const GET_ANALYTICS_MERCHANTS_FAILURE =
  "analytics/GET_ANALYTICS_MERCHANTS_FAILURE";
export const SET_GLOBAL_FILTERS = "analytics/SET_GLOBAL_FILTERS";
export const SET_GLOBAL_FILTERS_SELECTION =
  "analytics/SET_GLOBAL_FILTERS_SELECTION";
export const TOGGLE_EXPORT_MODAL = "analytics/TOGGLE_EXPORT_MODAL";

export const setPublicationsLoading = (loading: boolean) => ({
  type: SET_PUBLICATIONS_LOADING,
  payload: loading
});

export const getAggregatedMetrics = (
  flyer_run_ids: number[],
  merchant_id: number,
  start_date: string,
  end_date: string,
  metrics: string[]
) => ({
  type: GET_AGGREGATED_METRICS,
  payload: {
    merchant_id: merchant_id,
    flyer_run_ids: flyer_run_ids,
    start_date: start_date,
    end_date: end_date,
    metrics: metrics
  }
});

export const setAggregateMetricsLoading = (loading: boolean) => ({
  type: SET_AGGREGATED_METRICS_LOADING,
  payload: loading
});

export const addAggregatedMetrics = (metrics: AggregatedMetrics) => ({
  type: ADD_AGGREGATED_METRICS,
  payload: metrics
});

export const resetAggregatedMetrics = () => ({
  type: RESET_AGGREGATED_METRICS,
  payload: {
    clicks: null,
    impressions: null,
    item_views: null
  } as AggregatedMetrics
});

export const getAggregatedMetricsFailure = () => ({
  type: GET_AGGREGATED_METRICS_FAILURE
});

export const getPublications = (
  merchant_id: number,
  start_date: string,
  end_date: string
) => ({
  type: GET_PUBLICATIONS,
  payload: {
    merchant_id: merchant_id,
    start_date: start_date,
    end_date: end_date
  }
});

export const addPublications = (publications: any) => ({
  type: ADD_PUBLICATIONS,
  payload: publications
});

export const removePublications = () => ({
  type: REMOVE_PUBLICATIONS,
  payload: [] as any
});

export const getToplineMetricsFailure = () => ({
  type: GET_TOPLINE_METRICS_FAILURE
});

export const getPublicationsFailure = () => ({
  type: GET_PUBLICATIONS_FAILURE
});

export const setMetricsContainerTab = (tabname: string) => ({
  type: SET_METRICS_CONTAINER_TAB,
  payload: tabname
});

export const setStartDate = (start_date: string) => ({
  type: SET_START_DATE,
  payload: start_date
});

export const setEndDate = (end_date: string) => ({
  type: SET_END_DATE,
  payload: end_date
});

export const setMerchantSelection = (merchant_id: number) => ({
  type: SET_MERCHANT_SELECTION,
  payload: merchant_id
});

export const setPublicationSelection = (publicationIds: number[]) => ({
  type: SET_PUBLICATION_SELECTION,
  payload: publicationIds
});

export const getAnalyticsMerchants = (q?: string) => ({
  type: GET_ANALYTICS_MERCHANT,
  payload: q
});

export const getAnalyticsMerchantsFailure = () => ({
  type: GET_ANALYTICS_MERCHANTS_FAILURE
});

export const setGlobalFilters = (filters: AnalyticsGlobalFilters) => ({
  type: SET_GLOBAL_FILTERS,
  payload: filters
});

export const setGlobalFiltersSelection = (filters: AnalyticsGlobalFilters) => ({
  type: SET_GLOBAL_FILTERS_SELECTION,
  payload: filters
});

export const toggleExportModal = () => ({
  type: TOGGLE_EXPORT_MODAL
});

export const setMetricSelection = (metric: string, merchant_id: number) => ({
  type: SET_METRIC_SELECTION,
  payload: {
    metric: metric,
    merchant_id: merchant_id
  }
});



// WEBPACK FOOTER //
// ./client/modules/Analytics/actions.ts